import React from 'react';
import classnames from 'classnames';
import Style from './index.module.less';

const PageBox = ({ children, ...others }: React.HTMLAttributes<HTMLElement>) => (
  <div className={classnames(Style.pageBox)} {...others}>
    {children}
  </div>
);

export default React.memo(PageBox);
